"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBacklogSplit = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11 6V4.383a1 1 0 112 0V6h-2zm0 2h2v3.383h6.333a1 1 0 011 1V16h-2v-2.617H13V16h-2v-2.617H5.666V16h-2v-3.617a1 1 0 011-1H11V8z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4.667 2A.667.667 0 004 2.667v2.666c0 .368.298.667.667.667h14.666A.667.667 0 0020 5.333V2.667A.667.667 0 0019.333 2H4.667zM3.333 18a.667.667 0 00-.667.666v2.667c0 .368.298.667.667.667h2.666a.667.667 0 00.667-.667v-2.666A.667.667 0 005.999 18H3.333zm6.667.666c0-.368.298-.666.666-.666h2.667c.368 0 .667.298.667.666v2.667a.667.667 0 01-.667.667h-2.667a.667.667 0 01-.666-.667v-2.666zM18 18a.667.667 0 00-.667.666v2.667c0 .368.298.667.667.667h2.666a.667.667 0 00.667-.667v-2.666a.667.667 0 00-.667-.667H18z' }))); };
exports.default = SvgBacklogSplit;
//# sourceMappingURL=BacklogSplit.js.map